import { z } from 'zod';
export const SerializableVideoSlotSchema = z.object({
    id: z.string().min(1),
    x: z.number().min(0).max(1),
    y: z.number().min(0).max(1),
    width: z.number().min(0).max(1),
    height: z.number().min(0).max(1),
    sourceId: z.string().optional(),
    zIndex: z.number().int().default(0),
    // With a transparent background (the default) the letterboxed area of
    // the slot shows the scene behind it; opaque slots render as a black
    // tile.
    transparentBackground: z.boolean().default(true),
});
export const SerializableSceneSchema = z.object({
    id: z.string().min(1),
    name: z.string().min(1).max(68),
    layoutId: z.string().default('auto'),
    videoSlots: z.array(SerializableVideoSlotSchema),
    backgroundColor: z.string().optional(),
    backgroundSourceId: z.string().optional(),
});
function generateUUID() {
    try {
        return crypto.randomUUID();
    }
    catch (_) { }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
export function generateSceneId() {
    return generateUUID();
}
export function generateVideoSlotId() {
    return generateUUID();
}
export function createDefaultSerializableVideoSlot() {
    return {
        id: generateVideoSlotId(),
        x: 0.25,
        y: 0.25,
        width: 0.5,
        height: 0.5,
        zIndex: 0,
        transparentBackground: true,
    };
}
export function createDefaultSerializableScene(name = 'Scene 1', id = generateSceneId()) {
    // No video slots by default: the always-present background slot
    // (backgroundSourceId/backgroundColor) is the base of every scene,
    // and video slots are explicit additions on top of it.
    return {
        id,
        name,
        layoutId: 'auto',
        videoSlots: [],
    };
}
